export const IPIRANGA_PROMOTION_AVAILABLE = 'IPIRANGA_PROMOTION_AVAILABLE'
